<template>
    <div class="nav">
        <div class="content" :style="navBackgroundColor" v-if="!purecloud">
            <router-link tag="div" class="brand" :class="{open}" :to="homePage">
                <div class="logo" :style="navLogo"></div>
                <div class="logo-text" :style="navLogoExtended"></div>
            </router-link>

            <a class="menuitem" @click="toggleSidebar" v-if="showToggler">
                <i :class="{'icon-menu': !open, 'icon-arrow-left-circle': open}"></i>
            </a>

            <div class="search" v-if="showSearch">
            </div>
            <chat-init/>
            <div class="tools" v-if="showTools">
                <user-status v-if="$getPermission('casos.listar')" ></user-status>

                <div class="user-navbar">
                    <div class="avatar">
                        <span class="acronym">{{ $store.getters['auth/userAvatarName'] }}</span>
                        <el-popover :width="open ? 130 : 52" placement="bottom" trigger="click" v-model="userMenu">
                            <el-dropdown-item @click.native="profile"><i class="fas fa-user"></i><span class="ml-2" :class="{hidden: !open}">{{$t('profileS')}}</span></el-dropdown-item>
                            <el-dropdown-item @click.native="logout" divided><i class="fas fa-power-off text-danger"></i><span class="text-danger ml-2" :class="{hidden: !open}">{{$t('leave')}}</span></el-dropdown-item>
                            <button class="dropdown btn-avatar-menu" slot="reference">
                            </button>
                        </el-popover>
                    </div>
                </div>

                <el-popover placement="bottom" width="250" trigger="click" popper-class="list-noti" v-if="this.user.notificacionactiva === 1">
                    <ul class="lista-notificaciones">
                        <li class="titulo-noti">
                            <h3 class="font-semibold py-3 px-4 mb-0">{{$t('notifications.notificationSlo')}}</h3>
                        </li>

                        <li>
                            <div class="content-all-noti">
                                <a class="py-2 px-3" v-for="notificacion in allNavNotificacion" :key="notificacion.id" @click="abrirCasoNoti(notificacion)">
                                    <div class="btn-circle-noti mr-2" :style="{'background-color': notificacion.idprioridadcolor}"><i class="icon-drawer"></i></div>
                                    <div class="texto-notificacion">
                                        <span>{{$t('navbar.text1')}} {{ notificacion['refnum'] }} {{$t('navbar.text2')}}</span>
                                    </div>
                                </a>
                            </div>
                        </li>

                         <router-link tag="div" class="link-all-noti pt-3" :class="{open}" :to="{path: '/notificaciones' }" v-if="allNotificacionSLA.size > 10">
                            <strong>{{$t('notifications.seeAllNotifications')}} </strong> <i class="fa fa-angle-right"></i>
                        </router-link>
                    </ul>

                    <el-badge v-if="$getPermission('casos.listar')" :max="99" class="item menuitem dontShow" type="danger" slot="reference" :value="allNotificacionSLA.size===0 ? '' : allNotificacionSLA.size">
                        <i class="fas fa-bell"></i>
                    </el-badge>
                </el-popover>

                <audio id="playNotification" :loop="false">
                    <source src="../../assets/sounds/notification.mp3" type="audio/mp3">
                </audio>

                <el-popover v-if="$getPermission('casos.listar')" placement="bottom" width="250" trigger="click" popper-class="list-noti" @show="updateNoti">
                    <ul class="lista-notificaciones">
                        <li class="titulo-noti">
                            <h3 class="font-semibold py-3 px-4 mb-0">{{$t('notifications.caseInteractions')}}</h3>
                        </li>

                        <li>
                            <div class="content-all-noti">
                                <a class="py-2 px-3" v-for="notificacion in allNav" :key="notificacion.id" @click="seleccionarInteraccionNN(notificacion)">
                                    <div class="btn-circle-noti mr-2" :style="notificacion.idarchivo > 0 ? 'background-color: rgb(0, 174, 202);' : 'background-color: #037a8d'"><i :class="notificacion.idarchivo > 0 ?  'fas fa-paperclip' : 'far fa-envelope'"></i></div>
                                    <div class="texto-notificacion">
                                        <span v-if="notificacion.idusuario !== 0">
                                            <span v-html="notificacion['idusuariodesc']" style="display: initial!important;"></span>
                                            {{notificacion.idarchivo > 0 ? $t('hasAttach') : $t('hasSent')}}
                                        </span>

                                        <span class="caso-notificaciones" v-else>
                                            <span>{{$t('case.case')}}</span>
                                            <span v-html="notificacion['caso']" style="display: initial!important;"></span>
                                            {{ notificacion.texto.startsWith($t('caseAssignedTo')) 
                                                ? $t('assignedToUser')
                                                : $t('hasBeenUpdated')
                                            }}
                                        </span>
                                    </div>
                                </a>
                            </div>
                        </li>
                        <router-link tag="div" class="link-all-noti pt-3" :class="{open}" :to="{path: '/notificacionesNotes' }" v-if="allPaginationNav.size > 10">
                            <strong>{{$t('notifications.seeAllNotifications')}} </strong> <i class="fa fa-angle-right"></i>
                        </router-link>
                    </ul>
                    <el-badge :max="99" class="item menuitem dontShow" type="danger" slot="reference" :value="allPaginationNav.size===0 ? '' : allPaginationNav.size">
                        <i class="fas fa-users"></i>

                    </el-badge>
                </el-popover>

                <el-dropdown placement="top-start" trigger="click" class="reporteinc">
                      <a class="menuitem">
                        <i class="fas fa-question-circle text-white"></i>
                        <div class="radar"></div>
                        <div class="radar"></div>
                        <div class="radar"></div>
                      </a>
                    <el-dropdown-menu slot="dropdown">
                        <!--item oculto de forma temporal-->
                        <el-dropdown-item v-if="false">
                            <router-link to="/reportesinc" class="text-left"><i class="far fa-times-circle"></i> {{$t('navbar.reportIncident')}}</router-link>
                        </el-dropdown-item>
                        <!--item oculto de forma temporal-->
                        <el-dropdown-item>
                            <a href="https://wiki.beaware360.com/doku.php" target="_blank" v-tooltip.left="$t('navbar.tooltipWiki')" class="text-left block"><i class="fas fa-clipboard-list"></i> Wiki</a>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <a href="https://www.beawareacademy.com/" target="_blank" v-tooltip.left="$t('navbar.tooltipAcademy')" class="text-left block"><i class="fas fa-book"></i> Be Aware Academy</a>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <a href="https://www.linkedin.com/groups/12593361/" v-tooltip.left="$t('navbar.tooltipLinkedin')" target="_blank" class="text-left block"><i class="fab fa-linkedin"></i> LinkedIn</a>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <a href="https://servicedesk.portalbeaware.com/login" v-tooltip.left="$t('navbar.tooltipSupported')" target="_blank" class="text-left block"><i class="fas fa-hands-helping"></i> {{$t('navbar.support')}}</a>
                        </el-dropdown-item>
                        <el-dropdown-item divided>
                            <a @click="showAbout = !showAbout" class="text-left block" v-tooltip.left="$t('navbar.tooltipVersion')"><i class="fas fa-info-circle"></i> {{$t('navbar.about')}}</a>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>

            <about :visible.sync="showAbout"></about>
        </div>

        <div class="content" v-if="purecloud">
            <div class="brand purecloud">
                <div class="logo"></div>
                <div class="logo-text"></div>
            </div>

            <div class="search"></div>

            <div class="tools" v-if="!!this.$route.params.contactId">
                <div class="menuicon" v-if="purecloud">
                    <i :class="channelIcon"></i>
                </div>
                <router-link :to="{name: 'purecloud.contactos.editar', params: this.$route.params}" class="menuitem">
                    <i class="icon-user">
                        <span class="badge">
                            <i class="fas fa-search fa-xs"></i>
                        </span>
                    </i>
                </router-link>
                <router-link :to="{name: 'purecloud.casos.nuevo', params: this.$route.params}" class="menuitem">
                    <i class="icon-drawer">
                        <span class="badge">
                            <i class="fas fa-plus fa-xs"></i>
                        </span>
                    </i>
                </router-link>
            </div>

            <div class="tools" v-if="purecloud && !this.$route.params.contactId">
                <div class="menuicon">
                    <i :class="channelIcon"></i>
                </div>
            </div>
        </div>
        <change-pass-forced></change-pass-forced>
    </div>
</template>

<style lang="scss">

    @media screen and (max-width: 768px) {
        .reporteinc {
            display: none;
        }

        .dontShow {
            display: none!important;
        }
    }
    .caso-notificaciones {
        font-weight: bolder;

    }
    .lista-notificaciones {
        padding-left: 0!important;

        li {
            list-style: none;
        }

        .titulo-noti {
            h3 {
                border-bottom: 1px solid rgba(120, 130, 140, 0.13) !important;
            }
        }

        .link-all-noti {
            color: rgba(0, 0, 0, 0.5);
            text-align: center;
            border-top: 1px solid rgba(120, 130, 140, 0.13) !important;
            display: block;
            padding: 0.5rem 1rem;
            cursor: pointer;

            &:hover {
                color: rgba(0, 0, 0, 0.7);
            }

            &:focus {
                color: rgba(0, 0, 0, 0.7);
            }
        }

        .content-all-noti {
            width: auto;
            height: 250px;
            overflow: auto;

            a {
                text-decoration: none;
                display: block;
                border-bottom: 1px solid rgba(120, 130, 140, 0.13) !important;

                &:hover {
                    background-color: #f2f4f8;
                }

                .btn-circle-noti {
                    border-radius: 100%;
                    width: 40px;
                    height: 40px;
                    padding: 10px;
                    box-shadow: 0 2px 2px rgba(252, 75, 108, 0.05);
                    display: inline-block;
                    font-weight: 400;
                    color: #67757c;
                    text-align: center;
                    vertical-align: middle;
                    user-select: none;
                    background-color: #cbcdd1;
                    border: 1px solid transparent;
                    font-size: 0.875rem;
                    line-height: 1.5;
                    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

                    i {
                        color: #ffffff;
                    }
                }

                .texto-notificacion {
                    width: 75%;
                    display: inline-block;
                    vertical-align: middle !important;

                    span {
                        font-size: 12px;
                        color: #67757c;
                        display: block!important;
                    }
                }
            }
        }
    }
        .el-badge__content.is-fixed {
            top: 18px !important;
            font-size: 10px;
            right: 30px !important;
        }

    .list-noti {
        width: 300px!important;
        box-shadow: 0 3px 12px rgba(0, 0, 0, 0.05);
        -webkit-box-shadow: 0 3px 12px rgba(0, 0, 0, 0.05);
        -moz-box-shadow: 0 3px 12px rgba(0, 0, 0, 0.05);
        border-color: rgba(120, 130, 140, 0.13);
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 1000;
        float: left;
        min-width: 10rem;
        padding: 0.5rem 0;
        margin: 0.125rem 0 0;
        font-size: 0.875rem;
        color: #67757c;
        text-align: left;
        list-style: none;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 0.25rem;
    }

    .tools {
        .el-select {
            width: 100% !important;
            margin-right: 10px;
        }

        .btn-avatar-menu {
            width: 40px !important;
            height: 40px !important;
            left: 0 !important;
            top: 0 !important;
            border: 0 !important;
            background: transparent !important;
        }

        .el-input__inner {
            border: 0 !important;
            background: rgba(0, 0, 0, .2) !important;
            color: #fff;
            width: 150px;
            margin-left: 5px;
            border-radius: 5px;
            font-size: .8rem;
        }

        .el-input--prefix {
            margin-top: 10px !important;
        }

        .icono-disp {
            i {
                padding: 13px 10px;
                font-size: .85rem;
            }
        }

        @keyframes radar {
          0%{
              width:35px;
              height:35px;
              border:5px
              solid #fff;
              opacity:0
          }50%{
              opacity:.1
          }
          90%{
              width:50px;
              height:50px
          }
          90%,100%{
              border:1px
              solid #fff;
              opacity:0
          }100%{
              width:65px;
              height:65px
          }
        }

          .radar {
             position: absolute;
             top: 50%;
             left: 50%;
             border-radius: 50%;
             border: 10px solid #fff;
             width: 50px;
             height: 50px;
             -webkit-transform: translate(-50%,-50%);
             transform: translate(-50%,-50%);
             -webkit-animation: radar 2s infinite;
             animation: radar 2s infinite;
             opacity: 0;

              &:nth-child(2) {
                  animation-delay: .4s;
              }
              &:nth-child(3) {
                  animation-delay: .9s;
              }
              &:nth-child(4) {
                  animation-delay: .15s;
              }
          }
    }

    @media screen and (max-width: 768px) {
        .tools {
            .el-select {
                width: 67.7% !important;
            }

            .el-input__inner {
                border: 0 !important;
                background: rgba(0, 0, 0, 0.2) !important;
                color: #fff;
                width: 100%;
                min-width: 130px;
                margin-left: 5px;
                border-radius: 5px;
                font-size: .69rem;
            }

            .icono-disp {
                padding: 14px 10px;
                i {
                    padding: 14px 3px;
                    font-size: .7rem !important;
                }
            }
            .el-input--prefix {
                margin-top: 16px !important;
            }
        }
    }
</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getTimeIdle } from '@/plugins/userTimeout.js'
import isObject from 'lodash/isObject'
import { updateFavicon } from '@/util/favicon'
import Vue from 'vue'

export default {
  components: {
    About: () => import('@/components/About'),
    UserStatus: () => import('@/components/Inputs/UserStatus'),
    ChangePassForced: () => import('@/components/Inputs/ChangePassForced'),
    ChatInit: () => import('@/components/ChatInit')
  },
  data () {
    return {
      userMenu: false,
      showAbout: false,
      intervalNotas: null,
      intervalSLA: null,
      promiseAll: [],
      isIntervalRequest: true
    }
  },
  props: {
    showToggler: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    showTools: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('auth', ['user', 'homePage']),
    ...mapGetters(['open']),
    ...mapGetters('notificaciones', { notificaciones: 'all', paginationNoti: 'pagination', allNotificacionSLA: 'allPaginationNav', allNavNotificacion: 'allNav' }),
    ...mapGetters('notasNotificacion', { notasNotificaciones: 'all', paginationNotasArchivos: 'pagination', allPaginationNav: 'allPaginationNav', allNav: 'allNav' }),
    ...mapGetters('archivosNotas', { archivosNotas: 'all' }),
    ...mapGetters('roles', { allRoles: 'all', rol: 'one' }),
    ...mapGetters('actividadesprogramadas/ejecutivo', { ejec: 'one' }),
    ...mapGetters('personalizacionDesk', {theme: 'one'}),
    ...mapGetters('parametros', { allParametros: 'all' }),
    navLogo() {
      if(!this.theme.activo) {
        return `background-image: url(${require('@/assets/images/logo.png')})`
      } else {
        return this.theme.isotipo ? `background-image: url(data:image/jpeg;base64,${this.theme.isotipo})` : `background-image: url(${require('@/assets/images/logo.png')})`
      }
    },
    navLogoExtended() {
      if(!this.theme.activo) {
        return `background-image: url(${require('@/assets/images/logo-text.png')})`
      } else {
        return this.theme.logotipo ? `background-image: url(data:image/jpeg;base64,${this.theme.logotipo})` : `background-image: url(${require('@/assets/images/logo-text.png')})`
      }
    },
    navBackgroundColor() {
      if(!this.theme.activo) {
        return `background-image: linear-gradient(to right, #011c21, #037a8d)`
      } else {
        return this.theme.navbarleft && this.theme.navbarright ? `background-image: linear-gradient(to right, ${this.theme.navbarleft}, ${this.theme.navbarright})` : 'background-image: linear-gradient(to right, #011c21, #037a8d)'
      }
    },
    purecloud () {
      return this.$route.matched.some(record => record.meta.purecloud)
    },
    channelIcon () {
      let canal = this.$route.params.channel
      canal = canal.toLowerCase()
      if (canal === 'call' || canal === 'Call') {
        canal = 'voz'
      }
      switch (canal) {
        case 'voz':
          return 'fas fa-phone-square fa-2x'
        case 'chat':
          return 'fas fa-comments fa-2x'
        case 'email':
          return 'fas fa-envelope-square fa-2x'
        case 'sms':
          return 'fas fa-sms fa-2x'
        case 'twdirect':
          return 'fab fa-twitter-square fa-2x'
        case 'messenger':
          return 'fab fa-facebook-messenger fa-2x'
        case 'facebook':
          return 'fab fa-facebook fa-2x'
        case 'whatsapp':
          return 'fab fa-whatsapp fa-2x'
        case 'telegram':
          return 'fab fa-telegram fa-2x'
        case 'hangout':
          return 'icon-hangouts2'
        case 'instagram':
          return 'fab fa-instagram fa-2x'
        default:
          return ''
      }
    },
    params () {
      return Object.assign({}, { force: true, query: { pagina: 1, cantidad: 10, notificacion: 1 } }, {})
    },
    stateOfAzure () {
      return this.$store.state.auth.activeAzure
    },
    refreshNoteNotificationInterval: {
      get () {
        return isObject(this.allParametros.find(item => item.key === 'TIME_REFRESH_NOTES_NOTIFICATION')) ? this.allParametros.find(item => item.key === 'TIME_REFRESH_NOTES_NOTIFICATION').value : ''
      }
    },
    soundNoteNotification: {
      get () {
        return isObject(this.allParametros.find(item => item.key === 'SOUND_NOTES_NOTIFICATION')) ? this.allParametros.find(item => item.key === 'SOUND_NOTES_NOTIFICATION').value : ''
      }
    },
  },
  methods: {
    ...mapActions(['toggleSidebar']),
    ...mapActions('notificaciones', { getAllNotificaciones: 'getAllWL', getAllNotificacionesNav: 'getAllWLNav' }),
    ...mapActions('notasNotificacion', { getAllNotasNotificaciones: 'getAllWL', getAllNotasNotiNav: 'getAllWLNav' }),
    ...mapActions('archivosNotas', { getAllarchivosNotas: 'getAllWL' }),
    ...mapActions('roles', { getAllRoles: 'getAllWL' }),
    ...mapActions('personalizacionDesk', {getTheme: 'getBy'}),
    ...mapActions('parametros', { getAllParametros: 'getAll' }),
    profile () {
      this.$router.push({ name: 'perfil' })
      this.userMenu = false
    },
    logout () {
      // this.$store.dispatch('auth/logout').then(() => this.$router.push({ name: 'login' }))
      if (this.stateOfAzure === 'SI') {
        this.$store.dispatch('auth/logout')
          .then(() => {
            window.location.href = '/logoutAzure'
          })
      } else {
        this.$store.dispatch('auth/logout')
          .then(() => {
            if (Vue.$keycloak) {
              if (Vue.$keycloak.authenticated) {
                return
              }
            }
            window.location.href = '/'
          })
      }
      this.userMenu = false
    },
    getAll () {
      Promise.all([
        this.getAllRoles(),
        this.obtenerNotificaciones(),
        this.activarIntervaloSLA(),
        this.funcTimeOut(),
        this.getAllParametros({ force: true, query: { parametro: 1 } })          
      ]).then(() => {
        Promise.all([this.activarIntervaloNotas()])
      })
    },
    obtenerNotificaciones (tipo) {
      switch (tipo) {
        case 'SLA':
          this.promiseAll = [
            this.user.notificacionactiva == 1 ? this.getAllNotificacionesNav(this.params) : null
          ]
          break
        case 'Notas':
          this.promiseAll = [
            this.getAllNotasNotiNav({ force: true, query: { cantidad: 10, pagina: 1 } })
          ]
          break
        default:
          this.promiseAll = [
            this.user.notificacionactiva == 1 ? this.getAllNotificacionesNav(this.params) : null,
            this.getAllNotasNotiNav({ force: true, query: { cantidad: 10, pagina: 1 } })
          ]
          break
      }
      Promise.all(this.promiseAll)
        .then(() => {
          this.isIntervalRequest = true
        })
    },
    activarIntervaloSLA () {
      const datos = this
      this.intervalSLA = setInterval(() => {
        datos.obtenerNotificaciones('SLA')
        if (datos.$getPermission('actividades.ver')) {
          if ('geolocation' in navigator) {
            /* la geolocalización está disponible */
            // var obj = this
            navigator.geolocation.getCurrentPosition(function (position) {
              // obj.setValues(position.coords.latitude, position.coords.longitude)
              datos.ejec.latitud = position.coords.latitude
              datos.ejec.longitud = position.coords.longitude
              datos.$store.dispatch('actividadesprogramadas/ejecutivo/updateWL')
            })
          }
        }
      }, 180000) // 3min de intervalo para la llamada de notificaciones de SLA
    },
    activarIntervaloNotas () {
      const minutes = parseInt(this.refreshNoteNotificationInterval)
      const minutesToMilliseconds = minutes * 60 * 1000

      if (this.intervalNotas === null) {
        this.intervalNotas = setInterval(() => {
          this.obtenerNotificaciones('Notas')
        }, minutesToMilliseconds)
      }
    },
    updateNoti () {
      this.isIntervalRequest = false
      this.obtenerNotificaciones('Notas')

      clearInterval(this.intervalNotas)
      this.intervalNotas = null

      this.activarIntervaloNotas()
    },
    abrirCasoNoti (notificacion) {
      this.$store.dispatch('casos/getByGlobal', { id: notificacion.id }).then((data) => {
        this.$router.push({
          name: 'casos.editar', params: { id: notificacion.id }
        })
      })
    },
    seleccionarInteraccionNN (notasNotificacion) {
      this.$store.dispatch('notasNotificacion/custom', { method: 'put', endpoint: 'actividad/getusernotes/seen', dataToSend: { id: notasNotificacion.id } })
        .then((data) => {
          if (data.seen === 1) {
            this.$store.dispatch('casos/getByGlobal', { id: notasNotificacion.idobjeto }).then((data) => {
              this.$router.push({
                name: 'casos.editar', params: { id: notasNotificacion.idobjeto }
              })
              this.obtenerNotificaciones()
            })
          }
        })
    },
    seleccionarInteraccionAN (archivosNota) {
      this.$store.dispatch('archivosNotas/custom', { method: 'put', endpoint: 'archivos/getuserarchives/seen', dataToSend: { id: archivosNota.id } })
        .then((data) => {
          if (data.seen === 1) {
            this.$store.dispatch('archivosNotas/getAll', { force: true })
            this.$router.push({ path: '/casos/editar/' + archivosNota.idobjeto })
          }
        })
    },
    funcTimeOut () {
      getTimeIdle(this.$store.state.auth.company).then((result) => {
        const timeInactivity = result
        let CounterSeconds = 0

        document.onclick = function () {
          CounterSeconds = 0
        }

        document.onmousemove = function () {
          CounterSeconds = 0
        }

        document.onkeypress = function () {
          CounterSeconds = 0
        }

        window.setInterval(() => {
          CounterSeconds++
          if (CounterSeconds >= timeInactivity) {
            if (this.$store.state.auth.status) {
              this.$store.dispatch('auth/logout').then(() => {
                window.location.href = '/'
              })
            }
          }
        }, 1000)
      })
    }
  },
  beforeCreate() {
    this.$store.dispatch('personalizacionDesk/getBy', { id: 1 })
  },
  mounted () {
    this.getAll()
    if (this.theme.activo && this.theme.favicon) {
      updateFavicon(this.theme.favicon)
    }
  },
  watch: {   
    allPaginationNav (newV, falso) {
      if (newV.size > 0 && this.isIntervalRequest === true) {
        if (this.soundNoteNotification === 'SI') {
          for (let n of this.allNav) {
            if (n.texto.includes(this.$store.state.auth.user.nombre + " " + this.$store.state.auth.user.apellido)) {
              if((n.texto.includes("SONORA"))){               
                document.getElementById('playNotification').play();
                break;
              }              
            }
          }
        }
      }
    },
    'theme.activo': function () {
      if (this.theme.activo && this.theme.favicon) {
        updateFavicon(this.theme.favicon)
      }
    }
  }
}
</script>
